import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductCarouselComponent} from './product-carousel.component';
import {ProductCarouselTileComponent} from './product-carousel-tile/product-carousel-tile.component';
import {TranslateModule} from "@ngx-translate/core";
import {AddToCartButtonModule} from "@app/presentation/components/add-to-cart-button/add-to-cart-button.module";
import {AngularSvgIconModule} from "angular-svg-icon";
import {
    ProductPortraitTileModule
} from "@app/presentation/components/product-portrait-tile/product-portrait-tile.module";
import {
    ProductPortraitTileSkeletonModule
} from "@app/presentation/components/product-portrait-tile-skeleton/product-portrait-tile-skeleton.module";
import {DraggableCarouselComponent} from "@app/presentation/components/draggable-carousel/draggable-carousel.component";


@NgModule({
  declarations: [
    ProductCarouselComponent,
    ProductCarouselTileComponent
  ],
    imports: [
        CommonModule,
        TranslateModule,
        AddToCartButtonModule,
        AngularSvgIconModule,
        ProductPortraitTileModule,
        ProductPortraitTileSkeletonModule,
        DraggableCarouselComponent
    ],
  exports: [
      ProductCarouselComponent
  ]
})
export class ProductCarouselModule { }
